import { createFileRoute } from '@tanstack/react-router';
import { ReleaseNotesListView } from '@/features/release-notes/ReleaseNotesListView';
import { useViewAsId } from '@/lib/viewAs';

function ReleaseNotesRoute() {
  return <ReleaseNotesListView asUser={useViewAsId()} />;
}

export const Route = createFileRoute('/release-notes/')({ component: ReleaseNotesRoute });
